import {get} from "@iflat-ui/api/methods"

export default {
  async getItems() {
    const res = await get('/inspectionStatuses')
    return res.data
  }
}
